import gql from 'graphql-tag';

import { configTypes } from '../constants';

const LIMIT = 20;

export const queryNameForConfigType = {
  [configTypes.caseNumber]: 'suggestCaseNumbers',
  [configTypes.unitNumber]: 'suggestUnitNumbers',
  [configTypes.customerName]: 'suggestCustomers',
  [configTypes.inboundProgramName]: 'suggestInboundProgramNames',
  [configTypes.dealerName]: 'suggestDealerNames',
  [configTypes.poNumber]: 'suggestPoNumbers',
};

export const queryForConfigType = {
  [configTypes.caseNumber]: gql`
    query suggestCaseNumbers($searchValue: String) {
      suggestCaseNumbers(input: { prefix: $searchValue, limit: ${LIMIT} }) {
        values
      }
    }
  `,

  [configTypes.unitNumber]: gql`
    query suggestUnitNumbers($searchValue: String) {
      suggestUnitNumbers(input: { prefix: $searchValue, limit: ${LIMIT} }) {
        values
      }
    }
  `,

  [configTypes.customerName]: gql`
    query suggestCustomers($searchValue: String) {
      suggestCustomers(input: { prefix: $searchValue, limit: ${LIMIT} }) {
        values
      }
    }
  `,

  [configTypes.inboundProgramName]: gql`
    query suggestInboundProgramNames($searchValue: String) {
      suggestInboundProgramNames(
        input: { prefix: $searchValue, limit: ${LIMIT} }
      ) {
        values
      }
    }
  `,

  [configTypes.dealerName]: gql`
    query suggestDealerNames($searchValue: String) {
      suggestDealerNames(input: { prefix: $searchValue, limit: ${LIMIT} }) {
        values
      }
    }
  `,

  [configTypes.poNumber]: gql`
    query suggestPoNumbers($searchValue: String) {
      suggestPoNumbers(input: { prefix: $searchValue, limit: ${LIMIT} }) {
        values
      }
    }
  `,
};



// WEBPACK FOOTER //
// ./src/compositions/Reports/ReportConfigBuilder/InputFieldWithSuggestions/constants.js